<template>
  <menu>
    <div class="d-flex align-items-center">
      <span class="text-white ml-1">Menu:</span>
      <div>
        <el-select v-model="route" id="mobile-nav-select">
          <el-option
            v-for="(route, index) in routes"
            :value="route.path"
            :label="route.meta.menu.name"
            :key="index"
            @click.native="$router.push(route.path)"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </menu>
</template>

<script>
export default {
  data() {
    let route = this.$route.path;
    let s_route = route.split("/");

    return {
      route: s_route.splice(0, 2).join("/")
    };
  },
  computed: {
    user() {
      if (this.$store.getters["auth/user"]) {
        return this.$store.getters["auth/user"];
      }
      return {};
    },
    routes() {
      var routes = this.$router.options.routes[0].children.filter(o => {
        var result = false;
        if (o.hasOwnProperty("meta") && o.meta.hasOwnProperty("menu")) {
          if (
            o.meta.hasOwnProperty("userType") &&
            typeof o.meta.userType == "number"
          ) {
            if (this.user.user_type == o.meta.userType) result = true;
          } else if (
            o.meta.hasOwnProperty("userType") &&
            typeof o.meta.userType == "object"
          ) {
            if (
              o.meta.userType.find(o => {
                return o == this.user.user_type;
              })
            )
              result = true;
          } else {
            result = true;
          }
        }
        return result;
      });

      for (let route of routes) {
        route.submenus = [];
        if ("children" in route && route.children.length > 0) {
          let children = route.children;
          let submenus = [];
          for (let child of children) {
            if (
              child.hasOwnProperty("meta") &&
              child.meta.hasOwnProperty("menu")
            ) {
              if (
                child.meta.hasOwnProperty("userType") &&
                typeof child.meta.userType == "number"
              ) {
                if (this.user.user_type == child.meta.userType)
                  submenus.push(child);
              } else if (
                child.meta.hasOwnProperty("userType") &&
                typeof child.meta.userType == "object"
              ) {
                if (
                  child.meta.userType.find(o => {
                    return o == this.user.user_type;
                  })
                )
                  submenus.push(child);
              } else {
                submenus.push(child);
              }
            }
          }
          let sorted = submenus.sort((a, b) => {
            if (a.meta.menu.name < b.meta.menu.name) return -1;
            if (a.meta.menu.name > b.meta.menu.name) return 1;
            return 0;
          });
          route.submenus = sorted;
        }
      }

      routes.unshift({
        path: "/",
        meta: { menu: { name: "Dashboard" } }
      });

      return routes;
    }
  }
};
</script>

<style scoped lang="scss">
menu {
  margin: 0;
  padding: 0;
  background-color: #333;
}
</style>

<style lang="scss">
#mobile-nav-select {
  background-color: transparent;
  border: transparent;
  color: #fff;
}
.text-white {
  color: #fff;
}
</style>
